export const apiUrlTableAuth = 'table_stock/table-auth/';
